.PaginationControl {
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1;

  // Tooltip wrappers around IconButtons render as inline <span>s; force them
  // to align without contributing extra baseline space.
  > span {
    display: inline-flex;
    align-items: center;
  }
}

.pageInputGroup {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0 4px;
}
